import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card } from '@mui/material';

import NotFoundRecords from 'src/components/NotFoundRecords';
import MoffinParameterTable from './MoffinParameterTable';

const MoffinParameterList = ({ handleOpenEdit, parameters, loading }) => {
  if (!parameters.length)
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.PARAMETER_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.PARAMETER_DESCRIPTION"
        />
      </Card>
    );

  return (
    <Box mt={2}>
      <MoffinParameterTable
        parameters={parameters}
        loading={loading}
        handleOpenEdit={handleOpenEdit}
      />
    </Box>
  );
};

MoffinParameterList.propTypes = {
  handleOpenEdit: PropTypes.func,
  parameters: PropTypes.array,
  loading: PropTypes.bool
};

export default MoffinParameterList;
